export default __webpack_public_path__ + "static/media/TrovityImage.80f3eb03.svg";